<template>
	<li class="post col py-0" style="height: 60px;" >
		<div class="row my-auto mx-0 vertical-center">

			<div v-if="isEditableVal">
				<span class="column-drag-handle grabbable"><i class="fontello icon-menu"></i></span>
			</div>
			<div>
				<i class="fontello icon-handshake-o mr-2"/>
			</div>
			<div class="col p-0 h-100">
				<div class="my-auto">Agreement</div>
				<div class="my-auto text-muted">

					<small>
						{{programStep.name}}
					</small>
				</div>
			</div>
			<div v-if="!programStep.contract">
				<small class="mr-2 text-warning">Add agreement</small>
				<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
					<template #icon><span  class="dot badge-warning"></span></template>
					There is no agreement provided. Click to add one
					<br/>
					<br/>
					This row won't be visible to your client until you add an agreement.
				</ToolTipView>
				<!--				<i class="fontello icon-attention text-danger"/>-->
<!--				<span class="dot badge-danger"></span>-->
			</div>
			<div v-else-if="program.isProcess()" class="float-right text-right" >
				<div v-if="isCoach && clientsCount == 0" class="row mx-0 align-items-center">
					<small><div class="mr-2">Invite client to <br/>request signature</div></small>
					<span class="dot badge-warning"></span>
				</div>
				<span v-else>
					<small><span class="mr-2">{{programStep.contract.signStatusLabel(isClient)}}</span></small>
					<span class="dot" :class="[programStep.contract.signStatusClass()]"></span>
				</span>
			</div>
		</div>
	</li>
</template>

<script>
	import BaseRow from "./BaseRow"
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

	export default {
		name: "TaskRow",
		components: {ToolTipView},
		extends: BaseRow,
		props:{
			tooltipAnalyticsProps: Object
		}
	}
</script>

<style>

</style>
